import React, { FunctionComponent } from 'react';
import cx from 'clsx';
import styles from './Loader.module.scss';

interface OwnProps {
  loading?: boolean;
}

type LoaderProps = JSX.IntrinsicElements['div'] & OwnProps;

const Loader: FunctionComponent<LoaderProps> = props => {
  const { className, loading, ...rest } = props;

  const loaderContainerClassName = cx({
    [styles.container]: true,
    [styles.loading]: loading,
    ...(className && { [className]: true }),
  });

  return (
    <div className={loaderContainerClassName} {...rest}>
      <div className={styles.loader}>
        <span className={styles.element} />
      </div>
    </div>
  );
};

export default Loader;
